<template>
  <ul class="about-list list-unstyled open-sans-font">
    <li v-for="personalInfo in personalInfoContent" :key="personalInfo.id">
      <span class="title">{{ personalInfo.meta }}:  </span>
      <span
        class="value d-block d-sm-inline-block d-lg-block d-xl-inline-block"
      >
        {{ personalInfo.metaInfo }}
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {
      personalInfoContent: [
        { id: 1, meta: "Imię", metaInfo: "Łukasz" },
        { id: 2, meta: "Nazwisko", metaInfo: "Maśląg" },
        { id: 3, meta: "Wiek", metaInfo: "35 lat" },
        // { id: 4, meta: "", metaInfo: "Polska" },
        { id: 5, meta: "Freelance", metaInfo: "Available" },
        // { id: 6, meta: "Address", metaInfo: "Tunis" },
        // { id: 7, meta: "phone", metaInfo: "+21621184010" },
        { id: 8, meta: "Email", metaInfo: "lukasz@maslag.com" },
        // { id: 9, meta: "Skype", metaInfo: " steve.milner" },
        { id: 10, meta: "Języki", metaInfo: "Angielski" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
